<template>
  <!-- 清运记录 -->
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="台账编号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.ledgerNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="清理人">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.cleanUserId"
            placeholder="请输入"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="清理人">
          <el-select v-model="queryParam.cleanUserId" placeholder="请选择">
            <!-- <el-option label value></el-option> -->
            <el-option v-for="item in searchUserList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入人">
          <el-select v-model="queryParam.createUser" placeholder="请选择">
            <!-- <el-option label value></el-option> -->
            <el-option v-for="item in searchUserList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParam.status" placeholder="请选择">
            <el-option label value></el-option>
            <el-option label="待分配" value="1"></el-option>
            <el-option label="已分配" value="2"></el-option>
            <el-option label="处理中" value="3"></el-option>
            <el-option label="已完成" value="4"></el-option>
          </el-select>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">台账日期</span>
          <el-date-picker
            size="mini"
            v-model="ledgerDate"
            @change="ledgerDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
            <!-- :picker-options="expireTimeOption" -->
        <div class="selectBox">
          <span class="selectText">完成日期</span>
          <el-date-picker
            size="mini"
            v-model="doneLedgerDate"
            @change="doneLedgerDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button type="primary" @click="selectExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #ledgerDate="slotData">
        <span>
          {{slotData.data.row.ledgerDate ? slotData.data.row.ledgerDate.substr(0, 10) : ''}}
        </span>
      </template>
      <template #cleanUser="slotData">
        <span>
          {{userList[slotData.data.row.cleanUserId]}}
        </span>
      </template>
      <template #createUser="slotData">
        <span>
          {{userList[slotData.data.row.createUser]}}
        </span>
      </template>
      <template #status="slotData">
        <span>
          {{ledgerTypeCode[slotData.data.row.status]}}
        </span>
      </template>
      <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.ledgerPic"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.ledgerPic[0]"
          :preview-src-list="[slotData.data.row.ledgerPic[0]]"
          :key="slotData.data.row.id"
        >
          <div
            slot="error"
            class="image-slot"
            style="width: 100px; height: 50px"
          >
            <img
              src="@/assets/imgFail.png"
              alt
              style="width: 60px; height: 40px"
            />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleDetail(slotData.data.row)"
          >详情</el-button
        >
      </template>
    </e-table>
    <detailModal :ledgerDetail="ledgerDetail" :userList="userList" ref="detailModal"></detailModal>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import detailModal from "./component/detailModal.vue";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, detailModal },
  mixins: [listMixin],
  props: {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
    httpAction(this.url.userList, {}, "get").then((res) => {
      if (res.code !== 200) return this.$$message.warning(res.msg);
      this.userList = res.data.reduce((obj, item) => {
        obj[item.id] = item.name;
        return obj;
      }, {});
      this.searchUserList = res.data
    });
  },
  data() {
    return {
      ledgerDate: "",
      doneLedgerDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      deleteKey: "userId",
      url: {
        list: "/wlLedger/queryPage",
        userList: "/wlLedger/cleanUserList",
        exportXlsUrl: "/wlLedger/exportLedger",
      },

      //字段权限
      columns: [
        {
          field: "ledgerNo",
          label: "台账编号",
        },
        {
          field: "ledgerDate",
          label: "台账日期",
          slotName: "ledgerDate",
          columnType: "slot",
        },
        {
          field: "assignTime",
          label: "分配时间",
        },
        {
          field: "cleanUser",
          label: "清理人",
          slotName: "cleanUser",
          columnType: "slot",
        },
        {
          field: "ledgerPosition",
          label: "台账位置",
        },
        {
          width: 200,
          label: "台账照片",
          slotName: "photo",
          columnType: "slot",
        },
        {
          field: "status",
          label: "状态",
          slotName: "status",
          columnType: "slot",
        },
        {
          field: "createUser",
          label: "录入人",
          slotName: "createUser",
          columnType: "slot",
        },
        {
          width: 260,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      ledgerDetail: {},
      userList: [],
      ledgerTypeCode: {
        1: '待分配',
        2: '已分配',
        3: '处理中',
        4: '已完成',
      },
      searchUserList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    selectExport (e) {
      if (!this.queryParam.ledgerDateStart && !this.queryParam.ledgerDateEnd) return this.$message.warning("请选择台账日期后导出")
      this.handleExportXls('台账列表', this.url.exportXlsUrl)
    },
    ledgerDateChange(date) {
      if (date) {
        this.queryParam.ledgerDateStart = date[0] + " 00:00:00";
        this.queryParam.ledgerDateEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.ledgerDateStart = "";
        this.queryParam.ledgerDateEnd = "";
      }
    },
    doneLedgerDateChange (date) {
      if (date) {
        this.queryParam.doneTimeStart = date[0] + " 00:00:00";
        this.queryParam.doneTimeEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.doneTimeStart = "";
        this.queryParam.doneTimeEnd = "";
      }
    },
    searchReset() {
      this.queryParam = {};
      this.ledgerDate = "";
      this.doneLedgerDate = ""
      this.searchQuery();
    },
    async handleDetail(row) {
      this.ledgerDetail = {};
      this.$refs.detailModal.add();
      let res = await httpAction(`/wlLedger/detail/${row.id}`, {}, "get");
      if (res.code !== 200) return this.$message.warning(res.msg);
      this.ledgerDetail = res.data;
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
